module.exports = __webpack_public_path__ + "img/img.d0227e38.png";